import { Button, PageHeader } from 'components';
import { Form, Input, Row, Col, Select } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import useSiteCategory from '../useSiteCategory';

const SiteCategoryEdit = ({ isNew }) => {
  const { t } = useTranslation();
  const { form, handleCreateOrUpdate, loading, companyCategories } =
    useSiteCategory(false);

  const onFinish = async (values) => {
    await handleCreateOrUpdate(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const title = isNew
    ? t('CREARE CATEGORIE SITO')
    : t('MODIFICA CATEGORIE SITO');

  const handleCreate = () => {
    form.submit();
  };

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
          initialValues={{
            title_it: '',
            title_en: '',
            title_fr: '',
            company_category_id: '',
          }}
        >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                label={t('Titolo (Italiano)')}
                name='title_it'
                rules={[
                  { required: true, message: t('Il campo è obbligatorio') },
                ]}
              >
                <Input placeholder={t('Inserisci il titolo in italiano')} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={t('Titolo (Inglese)')} name='title_en'>
                <Input placeholder={t('Inserisci il titolo in inglese')} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={t('Titolo (Francese)')} name='title_fr'>
                <Input placeholder={t('Inserisci il titolo in francese')} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={t('Categorie insegne')}
                name='company_category_id'
              >
                <Select placeholder={t('Selezioni opzione')}>
                  <Select.Option value=''>{t('Selezioni opzione')}</Select.Option>
                  {companyCategories.map((item) => (
                    <Select.Option
                      key={item.id || item.value}
                      value={item.id || item.value}
                    >
                      {item.title}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Row gutter={16}>
          <Col>
            <Button
              onClick={handleCreate}
              width={'150px'}
              big
              icon={<CheckOutlined />}
              loading={loading}
            >
              {t('Invia')}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SiteCategoryEdit;
